module.exports = __webpack_public_path__ + "static/img/poster.f8f696a2.jpg";